import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=5518a6a5&scoped=true"
import script from "./scoreDetail.vue?vue&type=script&lang=js"
export * from "./scoreDetail.vue?vue&type=script&lang=js"
import style0 from "./scoreDetail.vue?vue&type=style&index=0&id=5518a6a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5518a6a5",
  null
  
)

export default component.exports